import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
async function deserializeResponseBody(response, dataType, dataFormat) {
    return ObjectSerializer.deserialize(await response.body.json(), dataType, dataFormat);
}
async function deserializeErrorBodyOrFallback(response, dataType, dataFormat) {
    try {
        return await deserializeResponseBody(response, dataType, dataFormat);
    }
    catch {
        return await response.getBodyAsAny();
    }
}
export class SnapshotsApiRequestFactory extends BaseAPIRequestFactory {
    async dynamoDBRestoreMethodAvailability(projectId, id, dynamoDBRestoreMethodAvailabilityRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "dynamoDBRestoreMethodAvailability", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "dynamoDBRestoreMethodAvailability", "id");
        }
        if (dynamoDBRestoreMethodAvailabilityRequest === null || dynamoDBRestoreMethodAvailabilityRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "dynamoDBRestoreMethodAvailability", "dynamoDBRestoreMethodAvailabilityRequest");
        }
        const localVarPath = '/projects/{projectId}/snapshots/{id}/dynamodb-restore-method-availability'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(dynamoDBRestoreMethodAvailabilityRequest, "DynamoDBRestoreMethodAvailabilityRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async exportAccessDeniedItems(projectId, id, snapshotId, exportAccessDeniedItemsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "exportAccessDeniedItems", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "exportAccessDeniedItems", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "exportAccessDeniedItems", "snapshotId");
        }
        if (exportAccessDeniedItemsRequest === null || exportAccessDeniedItemsRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "exportAccessDeniedItems", "exportAccessDeniedItemsRequest");
        }
        const localVarPath = '/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/export-access-denied-items'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(exportAccessDeniedItemsRequest, "ExportAccessDeniedItemsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getAzureSqlDatabaseNativePitrWindow(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "getAzureSqlDatabaseNativePitrWindow", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "getAzureSqlDatabaseNativePitrWindow", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/azure-sql-database-native-pitr-window'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getPitrRestoreWindows(projectId, id, startTime, endTime, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "getPitrRestoreWindows", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "getPitrRestoreWindows", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/pitr-restore-windows'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (startTime !== undefined) {
            requestContext.setQueryParam("startTime", ObjectSerializer.serialize(startTime, "Date", "date-time"));
        }
        if (endTime !== undefined) {
            requestContext.setQueryParam("endTime", ObjectSerializer.serialize(endTime, "Date", "date-time"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getRdsNativePitrWindow(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "getRdsNativePitrWindow", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "getRdsNativePitrWindow", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/rds-native-pitr-window'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSnapshot(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "getSnapshot", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "getSnapshot", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/snapshots/{id}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSnapshotCoverage(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "getSnapshotCoverage", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "getSnapshotCoverage", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/snapshots/{id}/coverage'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getUnifiedIdentityRestorePlan(projectId, id, snapshotId, entityIds, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "getUnifiedIdentityRestorePlan", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "getUnifiedIdentityRestorePlan", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "getUnifiedIdentityRestorePlan", "snapshotId");
        }
        if (entityIds === null || entityIds === undefined) {
            throw new RequiredError("SnapshotsApi", "getUnifiedIdentityRestorePlan", "entityIds");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/unified-identity-restore-plan'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (entityIds !== undefined) {
            requestContext.setQueryParam("entityIds", ObjectSerializer.serialize(entityIds, "string", "tobedefined"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async holdSnapshot(projectId, id, holdSnapshotRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "holdSnapshot", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "holdSnapshot", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/snapshots/{id}/hold'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(holdSnapshotRequest, "HoldSnapshotRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listAzureSqlRestoreTargetServers(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "listAzureSqlRestoreTargetServers", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "listAzureSqlRestoreTargetServers", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/azure-sql-restore-target-servers'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listEksClusterSnapshotNamespaces(projectId, id, snapshotId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "listEksClusterSnapshotNamespaces", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "listEksClusterSnapshotNamespaces", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "listEksClusterSnapshotNamespaces", "snapshotId");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/eks-namespaces'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listEksRestoreTargetClusters(projectId, id, region, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "listEksRestoreTargetClusters", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "listEksRestoreTargetClusters", "id");
        }
        if (region === null || region === undefined) {
            throw new RequiredError("SnapshotsApi", "listEksRestoreTargetClusters", "region");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/eks-restore-target-clusters'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (region !== undefined) {
            requestContext.setQueryParam("region", ObjectSerializer.serialize(region, "string", "tobedefined"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listResourceSnapshots(projectId, id, pageToken, pageSize, listInventorySnapshotsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "listResourceSnapshots", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "listResourceSnapshots", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listInventorySnapshotsRequest, "ListInventorySnapshotsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async removeSnapshotHold(projectId, id, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "removeSnapshotHold", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "removeSnapshotHold", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/snapshots/{id}/remove-hold'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureDisk(projectId, id, snapshotId, restoreAzureDiskRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureDisk", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureDisk", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureDisk", "snapshotId");
        }
        if (restoreAzureDiskRequest === null || restoreAzureDiskRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureDisk", "restoreAzureDiskRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-azure-disk'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureDiskRequest, "RestoreAzureDiskRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureEntraId(projectId, id, snapshotId, restoreAzureEntraIdRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureEntraId", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureEntraId", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureEntraId", "snapshotId");
        }
        if (restoreAzureEntraIdRequest === null || restoreAzureEntraIdRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureEntraId", "restoreAzureEntraIdRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-azure-entra-id'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureEntraIdRequest, "RestoreAzureEntraIdRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureFileShare(projectId, id, restoreAzureFileShareRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureFileShare", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureFileShare", "id");
        }
        if (restoreAzureFileShareRequest === null || restoreAzureFileShareRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureFileShare", "restoreAzureFileShareRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/restore-azure-file-share'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureFileShareRequest, "RestoreAzureFileShareRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzurePostgresDatabase(projectId, id, snapshotId, restoreAzurePostgresDatabaseRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzurePostgresDatabase", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzurePostgresDatabase", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzurePostgresDatabase", "snapshotId");
        }
        if (restoreAzurePostgresDatabaseRequest === null || restoreAzurePostgresDatabaseRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzurePostgresDatabase", "restoreAzurePostgresDatabaseRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-azure-postgres'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzurePostgresDatabaseRequest, "RestoreAzurePostgresDatabaseRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureSqlDatabase(projectId, id, snapshotId, restoreAzureSqlDatabaseRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlDatabase", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlDatabase", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlDatabase", "snapshotId");
        }
        if (restoreAzureSqlDatabaseRequest === null || restoreAzureSqlDatabaseRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlDatabase", "restoreAzureSqlDatabaseRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-azure-sql-database'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureSqlDatabaseRequest, "RestoreAzureSqlDatabaseRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureSqlDatabaseNativePitr(projectId, id, restoreAzureSqlDatabaseNativePitrRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlDatabaseNativePitr", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlDatabaseNativePitr", "id");
        }
        if (restoreAzureSqlDatabaseNativePitrRequest === null || restoreAzureSqlDatabaseNativePitrRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlDatabaseNativePitr", "restoreAzureSqlDatabaseNativePitrRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/restore-azure-sql-database-native-pitr'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureSqlDatabaseNativePitrRequest, "RestoreAzureSqlDatabaseNativePitrRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureSqlVmPitr(projectId, id, restoreAzureSqlVmPitrRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlVmPitr", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlVmPitr", "id");
        }
        if (restoreAzureSqlVmPitrRequest === null || restoreAzureSqlVmPitrRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureSqlVmPitr", "restoreAzureSqlVmPitrRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/restore-azure-sql-vm-pitr'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureSqlVmPitrRequest, "RestoreAzureSqlVmPitrRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureVmInstance(projectId, id, snapshotId, restoreAzureVmInstanceRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureVmInstance", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureVmInstance", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureVmInstance", "snapshotId");
        }
        if (restoreAzureVmInstanceRequest === null || restoreAzureVmInstanceRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureVmInstance", "restoreAzureVmInstanceRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-azure-vm-instance'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureVmInstanceRequest, "RestoreAzureVmInstanceRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreAzureVmNative(projectId, id, restoreAzureVmNativeRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureVmNative", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureVmNative", "id");
        }
        if (restoreAzureVmNativeRequest === null || restoreAzureVmNativeRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreAzureVmNative", "restoreAzureVmNativeRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/restore-azure-vm-native'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAzureVmNativeRequest, "RestoreAzureVmNativeRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreBigQueryDataset(projectId, id, snapshotId, restoreBigQueryDatasetRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBigQueryDataset", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBigQueryDataset", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBigQueryDataset", "snapshotId");
        }
        if (restoreBigQueryDatasetRequest === null || restoreBigQueryDatasetRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBigQueryDataset", "restoreBigQueryDatasetRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-bigquery-dataset'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreBigQueryDatasetRequest, "RestoreBigQueryDatasetRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreBigQueryNativePitr(projectId, id, restoreBigQueryNativePitrRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBigQueryNativePitr", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBigQueryNativePitr", "id");
        }
        if (restoreBigQueryNativePitrRequest === null || restoreBigQueryNativePitrRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBigQueryNativePitr", "restoreBigQueryNativePitrRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/restore-gcp-bigquery-native-pitr'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreBigQueryNativePitrRequest, "RestoreBigQueryNativePitrRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreBucket(projectId, id, snapshotId, restoreBucketRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBucket", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBucket", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBucket", "snapshotId");
        }
        if (restoreBucketRequest === null || restoreBucketRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreBucket", "restoreBucketRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-bucket'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreBucketRequest, "RestoreBucketRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreCassandraCluster(projectId, id, snapshotId, restoreAwsCassandraClusterRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreCassandraCluster", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreCassandraCluster", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreCassandraCluster", "snapshotId");
        }
        if (restoreAwsCassandraClusterRequest === null || restoreAwsCassandraClusterRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreCassandraCluster", "restoreAwsCassandraClusterRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-cassandra-cluster'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAwsCassandraClusterRequest, "RestoreAwsCassandraClusterRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreDatabase(projectId, id, snapshotId, restoreDbToRdsInstanceRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDatabase", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDatabase", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDatabase", "snapshotId");
        }
        if (restoreDbToRdsInstanceRequest === null || restoreDbToRdsInstanceRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDatabase", "restoreDbToRdsInstanceRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-rds-instance'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreDbToRdsInstanceRequest, "RestoreDbToRdsInstanceRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreDbToRdsSnapshot(projectId, id, snapshotId, restoreDbToRdsSnapshotRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDbToRdsSnapshot", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDbToRdsSnapshot", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDbToRdsSnapshot", "snapshotId");
        }
        if (restoreDbToRdsSnapshotRequest === null || restoreDbToRdsSnapshotRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDbToRdsSnapshot", "restoreDbToRdsSnapshotRequest");
        }
        const localVarPath = '/projects/{projectId}/inventory/{id}/snapshots/{snapshotId}/restore-db-to-rds-snapshot'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreDbToRdsSnapshotRequest, "RestoreDbToRdsSnapshotRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreDocumentdb(projectId, id, snapshotId, restoreDocumentDBRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDocumentdb", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDocumentdb", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDocumentdb", "snapshotId");
        }
        if (restoreDocumentDBRequest === null || restoreDocumentDBRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDocumentdb", "restoreDocumentDBRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-documentdb'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreDocumentDBRequest, "RestoreDocumentDBRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreDynamoDBTable(projectId, id, snapshotId, restoreDynamoDBTableRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBTable", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBTable", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBTable", "snapshotId");
        }
        if (restoreDynamoDBTableRequest === null || restoreDynamoDBTableRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBTable", "restoreDynamoDBTableRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-dynamo-db-table'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreDynamoDBTableRequest, "RestoreDynamoDBTableRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreDynamoDBToExistingTable(projectId, id, snapshotId, restoreDynamoDBToExistingTableRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToExistingTable", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToExistingTable", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToExistingTable", "snapshotId");
        }
        if (restoreDynamoDBToExistingTableRequest === null || restoreDynamoDBToExistingTableRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToExistingTable", "restoreDynamoDBToExistingTableRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-dynamodb-to-existing'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreDynamoDBToExistingTableRequest, "RestoreDynamoDBToExistingTableRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreDynamoDBToS3(projectId, id, snapshotId, restoreDynamoDBToS3Request, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToS3", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToS3", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToS3", "snapshotId");
        }
        if (restoreDynamoDBToS3Request === null || restoreDynamoDBToS3Request === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreDynamoDBToS3", "restoreDynamoDBToS3Request");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-dynamodb-to-s3'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreDynamoDBToS3Request, "RestoreDynamoDBToS3Request", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreEFS(projectId, id, snapshotId, restoreEFSRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEFS", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEFS", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEFS", "snapshotId");
        }
        if (restoreEFSRequest === null || restoreEFSRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEFS", "restoreEFSRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-efs'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreEFSRequest, "RestoreEFSRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreEbsVolume(projectId, id, snapshotId, restoreVolumeToEbsRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEbsVolume", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEbsVolume", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEbsVolume", "snapshotId");
        }
        if (restoreVolumeToEbsRequest === null || restoreVolumeToEbsRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEbsVolume", "restoreVolumeToEbsRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-ec2-ebs-volume'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreVolumeToEbsRequest, "RestoreVolumeToEbsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreEc2Instance(projectId, id, snapshotId, restoreAwsEc2InstanceRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEc2Instance", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEc2Instance", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEc2Instance", "snapshotId");
        }
        if (restoreAwsEc2InstanceRequest === null || restoreAwsEc2InstanceRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEc2Instance", "restoreAwsEc2InstanceRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-ec2-instance'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAwsEc2InstanceRequest, "RestoreAwsEc2InstanceRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreEksCluster(projectId, id, snapshotId, restoreEksClusterRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEksCluster", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEksCluster", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEksCluster", "snapshotId");
        }
        if (restoreEksClusterRequest === null || restoreEksClusterRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEksCluster", "restoreEksClusterRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-eks-cluster'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreEksClusterRequest, "RestoreEksClusterRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreEntraIdWithMicrosoft365(projectId, id, snapshotId, restoreEntraIdWithMicrosoft365Request, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEntraIdWithMicrosoft365", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEntraIdWithMicrosoft365", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEntraIdWithMicrosoft365", "snapshotId");
        }
        if (restoreEntraIdWithMicrosoft365Request === null || restoreEntraIdWithMicrosoft365Request === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreEntraIdWithMicrosoft365", "restoreEntraIdWithMicrosoft365Request");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-entra-id-with-microsoft-365'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreEntraIdWithMicrosoft365Request, "RestoreEntraIdWithMicrosoft365Request", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreFSx(projectId, id, snapshotId, restoreFSxRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFSx", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFSx", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFSx", "snapshotId");
        }
        if (restoreFSxRequest === null || restoreFSxRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFSx", "restoreFSxRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-fsx'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreFSxRequest, "RestoreFSxRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreFiles(projectId, id, snapshotId, restoreFilesRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFiles", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFiles", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFiles", "snapshotId");
        }
        if (restoreFilesRequest === null || restoreFilesRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreFiles", "restoreFilesRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-files'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreFilesRequest, "RestoreFilesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGcpCloudSql(projectId, id, snapshotId, restoreGcpCloudSqlRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpCloudSql", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpCloudSql", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpCloudSql", "snapshotId");
        }
        if (restoreGcpCloudSqlRequest === null || restoreGcpCloudSqlRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpCloudSql", "restoreGcpCloudSqlRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-gcp-cloudsql'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGcpCloudSqlRequest, "RestoreGcpCloudSqlRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGcpDisk(projectId, id, snapshotId, restoreGcpDiskRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpDisk", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpDisk", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpDisk", "snapshotId");
        }
        if (restoreGcpDiskRequest === null || restoreGcpDiskRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpDisk", "restoreGcpDiskRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-gcp-disk'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGcpDiskRequest, "RestoreGcpDiskRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGcpVmInstance(projectId, id, snapshotId, restoreGcpVmInstanceRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpVmInstance", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpVmInstance", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpVmInstance", "snapshotId");
        }
        if (restoreGcpVmInstanceRequest === null || restoreGcpVmInstanceRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGcpVmInstance", "restoreGcpVmInstanceRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-gcp-vm-instance'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGcpVmInstanceRequest, "RestoreGcpVmInstanceRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspace(projectId, id, snapshotId, restoreGoogleWorkspaceRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspace", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspace", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspace", "snapshotId");
        }
        if (restoreGoogleWorkspaceRequest === null || restoreGoogleWorkspaceRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspace", "restoreGoogleWorkspaceRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-google-workspace'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceRequest, "RestoreGoogleWorkspaceRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceDrive(projectId, id, snapshotId, restoreGoogleWorkspaceDriveRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceDrive", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceDrive", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceDrive", "snapshotId");
        }
        if (restoreGoogleWorkspaceDriveRequest === null || restoreGoogleWorkspaceDriveRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceDrive", "restoreGoogleWorkspaceDriveRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-google-workspace-drive'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceDriveRequest, "RestoreGoogleWorkspaceDriveRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceGroup(projectId, id, snapshotId, restoreGoogleWorkspaceGroupRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroup", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroup", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroup", "snapshotId");
        }
        if (restoreGoogleWorkspaceGroupRequest === null || restoreGoogleWorkspaceGroupRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroup", "restoreGoogleWorkspaceGroupRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-google-workspace-group'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceGroupRequest, "RestoreGoogleWorkspaceGroupRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceGroupByEntity(projectId, id, saasEntityId, snapshotId, restoreGoogleWorkspaceGroupByEntityRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupByEntity", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupByEntity", "id");
        }
        if (saasEntityId === null || saasEntityId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupByEntity", "saasEntityId");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupByEntity", "snapshotId");
        }
        if (restoreGoogleWorkspaceGroupByEntityRequest === null || restoreGoogleWorkspaceGroupByEntityRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupByEntity", "restoreGoogleWorkspaceGroupByEntityRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities/{saasEntityId}/snapshots/{snapshotId}/restore-google-workspace-group-by-entity'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'saasEntityId' + '}', encodeURIComponent(String(saasEntityId)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceGroupByEntityRequest, "RestoreGoogleWorkspaceGroupByEntityRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceGroupMessages(projectId, id, snapshotId, restoreGoogleWorkspaceGroupMessagesRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessages", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessages", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessages", "snapshotId");
        }
        if (restoreGoogleWorkspaceGroupMessagesRequest === null || restoreGoogleWorkspaceGroupMessagesRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessages", "restoreGoogleWorkspaceGroupMessagesRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-google-workspace-group-messages'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceGroupMessagesRequest, "RestoreGoogleWorkspaceGroupMessagesRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceGroupMessagesByEntity(projectId, id, saasEntityId, snapshotId, restoreGoogleWorkspaceGroupMessagesByEntityRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessagesByEntity", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessagesByEntity", "id");
        }
        if (saasEntityId === null || saasEntityId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessagesByEntity", "saasEntityId");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessagesByEntity", "snapshotId");
        }
        if (restoreGoogleWorkspaceGroupMessagesByEntityRequest === null || restoreGoogleWorkspaceGroupMessagesByEntityRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceGroupMessagesByEntity", "restoreGoogleWorkspaceGroupMessagesByEntityRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities/{saasEntityId}/snapshots/{snapshotId}/restore-google-workspace-group-messages-by-entity'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'saasEntityId' + '}', encodeURIComponent(String(saasEntityId)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceGroupMessagesByEntityRequest, "RestoreGoogleWorkspaceGroupMessagesByEntityRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceMail(projectId, id, snapshotId, restoreGoogleWorkspaceMailRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceMail", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceMail", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceMail", "snapshotId");
        }
        if (restoreGoogleWorkspaceMailRequest === null || restoreGoogleWorkspaceMailRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceMail", "restoreGoogleWorkspaceMailRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-google-workspace-mail'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceMailRequest, "RestoreGoogleWorkspaceMailRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceSharedDrive(projectId, id, snapshotId, restoreGoogleWorkspaceSharedDriveRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDrive", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDrive", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDrive", "snapshotId");
        }
        if (restoreGoogleWorkspaceSharedDriveRequest === null || restoreGoogleWorkspaceSharedDriveRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDrive", "restoreGoogleWorkspaceSharedDriveRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-google-workspace-shared-drive'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceSharedDriveRequest, "RestoreGoogleWorkspaceSharedDriveRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceSharedDriveByEntity(projectId, id, saasEntityId, snapshotId, restoreGoogleWorkspaceSharedDriveByEntityRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDriveByEntity", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDriveByEntity", "id");
        }
        if (saasEntityId === null || saasEntityId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDriveByEntity", "saasEntityId");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDriveByEntity", "snapshotId");
        }
        if (restoreGoogleWorkspaceSharedDriveByEntityRequest === null || restoreGoogleWorkspaceSharedDriveByEntityRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceSharedDriveByEntity", "restoreGoogleWorkspaceSharedDriveByEntityRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities/{saasEntityId}/snapshots/{snapshotId}/restore-google-workspace-shared-drive-by-entity'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'saasEntityId' + '}', encodeURIComponent(String(saasEntityId)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceSharedDriveByEntityRequest, "RestoreGoogleWorkspaceSharedDriveByEntityRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceUser(projectId, id, snapshotId, restoreGoogleWorkspaceUserRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUser", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUser", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUser", "snapshotId");
        }
        if (restoreGoogleWorkspaceUserRequest === null || restoreGoogleWorkspaceUserRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUser", "restoreGoogleWorkspaceUserRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-google-workspace-user'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceUserRequest, "RestoreGoogleWorkspaceUserRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceUserByEntity(projectId, id, saasEntityId, snapshotId, restoreGoogleWorkspaceUserByEntityRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserByEntity", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserByEntity", "id");
        }
        if (saasEntityId === null || saasEntityId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserByEntity", "saasEntityId");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserByEntity", "snapshotId");
        }
        if (restoreGoogleWorkspaceUserByEntityRequest === null || restoreGoogleWorkspaceUserByEntityRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserByEntity", "restoreGoogleWorkspaceUserByEntityRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities/{saasEntityId}/snapshots/{snapshotId}/restore-google-workspace-user-by-entity'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'saasEntityId' + '}', encodeURIComponent(String(saasEntityId)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceUserByEntityRequest, "RestoreGoogleWorkspaceUserByEntityRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceUserDriveByEntity(projectId, id, saasEntityId, snapshotId, restoreGoogleWorkspaceUserDriveByEntityRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserDriveByEntity", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserDriveByEntity", "id");
        }
        if (saasEntityId === null || saasEntityId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserDriveByEntity", "saasEntityId");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserDriveByEntity", "snapshotId");
        }
        if (restoreGoogleWorkspaceUserDriveByEntityRequest === null || restoreGoogleWorkspaceUserDriveByEntityRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserDriveByEntity", "restoreGoogleWorkspaceUserDriveByEntityRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities/{saasEntityId}/snapshots/{snapshotId}/restore-google-workspace-user-drive-by-entity'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'saasEntityId' + '}', encodeURIComponent(String(saasEntityId)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceUserDriveByEntityRequest, "RestoreGoogleWorkspaceUserDriveByEntityRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreGoogleWorkspaceUserMailByEntity(projectId, id, saasEntityId, snapshotId, restoreGoogleWorkspaceUserMailByEntityRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserMailByEntity", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserMailByEntity", "id");
        }
        if (saasEntityId === null || saasEntityId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserMailByEntity", "saasEntityId");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserMailByEntity", "snapshotId");
        }
        if (restoreGoogleWorkspaceUserMailByEntityRequest === null || restoreGoogleWorkspaceUserMailByEntityRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreGoogleWorkspaceUserMailByEntity", "restoreGoogleWorkspaceUserMailByEntityRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/saas-entities/{saasEntityId}/snapshots/{snapshotId}/restore-google-workspace-user-mail-by-entity'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'saasEntityId' + '}', encodeURIComponent(String(saasEntityId)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreGoogleWorkspaceUserMailByEntityRequest, "RestoreGoogleWorkspaceUserMailByEntityRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreKeyspacesTable(projectId, id, snapshotId, restoreKeyspacesTableRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreKeyspacesTable", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreKeyspacesTable", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreKeyspacesTable", "snapshotId");
        }
        if (restoreKeyspacesTableRequest === null || restoreKeyspacesTableRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreKeyspacesTable", "restoreKeyspacesTableRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-keyspaces-table'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreKeyspacesTableRequest, "RestoreKeyspacesTableRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreMicrosoft365(projectId, id, snapshotId, restoreMicrosoft365Request, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365", "snapshotId");
        }
        if (restoreMicrosoft365Request === null || restoreMicrosoft365Request === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365", "restoreMicrosoft365Request");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-microsoft-365'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreMicrosoft365Request, "RestoreMicrosoft365Request", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreMicrosoft365Drive(projectId, id, snapshotId, restoreMicrosoft365ItemsRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Drive", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Drive", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Drive", "snapshotId");
        }
        if (restoreMicrosoft365ItemsRequest === null || restoreMicrosoft365ItemsRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Drive", "restoreMicrosoft365ItemsRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-microsoft-365-drive'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreMicrosoft365ItemsRequest, "RestoreMicrosoft365ItemsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreMicrosoft365Mail(projectId, id, snapshotId, restoreMicrosoft365ItemsRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Mail", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Mail", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Mail", "snapshotId");
        }
        if (restoreMicrosoft365ItemsRequest === null || restoreMicrosoft365ItemsRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Mail", "restoreMicrosoft365ItemsRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-microsoft-365-mail'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreMicrosoft365ItemsRequest, "RestoreMicrosoft365ItemsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreMicrosoft365Site(projectId, id, snapshotId, restoreMicrosoft365ItemsRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Site", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Site", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Site", "snapshotId");
        }
        if (restoreMicrosoft365ItemsRequest === null || restoreMicrosoft365ItemsRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365Site", "restoreMicrosoft365ItemsRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-microsoft-365-site'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreMicrosoft365ItemsRequest, "RestoreMicrosoft365ItemsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreMicrosoft365User(projectId, id, snapshotId, restoreMicrosoft365UserRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365User", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365User", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365User", "snapshotId");
        }
        if (restoreMicrosoft365UserRequest === null || restoreMicrosoft365UserRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreMicrosoft365User", "restoreMicrosoft365UserRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-microsoft-365-user'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreMicrosoft365UserRequest, "RestoreMicrosoft365UserRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreNeptune(projectId, id, snapshotId, restoreNeptuneRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreNeptune", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreNeptune", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreNeptune", "snapshotId");
        }
        if (restoreNeptuneRequest === null || restoreNeptuneRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreNeptune", "restoreNeptuneRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-neptune'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreNeptuneRequest, "RestoreNeptuneRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreOpenSearchDomain(projectId, id, snapshotId, restoreAwsOpenSearchDomainRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreOpenSearchDomain", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreOpenSearchDomain", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreOpenSearchDomain", "snapshotId");
        }
        if (restoreAwsOpenSearchDomainRequest === null || restoreAwsOpenSearchDomainRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreOpenSearchDomain", "restoreAwsOpenSearchDomainRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/restore-opensearch-domain'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreAwsOpenSearchDomainRequest, "RestoreAwsOpenSearchDomainRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreRdsNativePitr(projectId, id, restoreRdsNativePitrRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreRdsNativePitr", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreRdsNativePitr", "id");
        }
        if (restoreRdsNativePitrRequest === null || restoreRdsNativePitrRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreRdsNativePitr", "restoreRdsNativePitrRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/restore-rds-native-pitr'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreRdsNativePitrRequest, "RestoreRdsNativePitrRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async restoreToEbsSnapshot(projectId, id, snapshotId, restoreVolumeToEbsSnapshotRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreToEbsSnapshot", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreToEbsSnapshot", "id");
        }
        if (snapshotId === null || snapshotId === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreToEbsSnapshot", "snapshotId");
        }
        if (restoreVolumeToEbsSnapshotRequest === null || restoreVolumeToEbsSnapshotRequest === undefined) {
            throw new RequiredError("SnapshotsApi", "restoreToEbsSnapshot", "restoreVolumeToEbsSnapshotRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/resources/{id}/snapshots/{snapshotId}/convert-ec2-ebs-snapshot'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
            .replace('{' + 'snapshotId' + '}', encodeURIComponent(String(snapshotId)));
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(restoreVolumeToEbsSnapshotRequest, "RestoreVolumeToEbsSnapshotRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class SnapshotsApiResponseProcessor {
    async dynamoDBRestoreMethodAvailabilityWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DynamoDBRestoreMethodAvailabilityResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., Auto restoreMethod not supported).", undefined, response.headers, response);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore method not available for this account (e.g., feature not enabled).", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async exportAccessDeniedItemsWithHttpInfo(response) {
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Bad request.", undefined, response.headers, response);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Forbidden.", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Resource or snapshot not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getAzureSqlDatabaseNativePitrWindowWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RdsNativePitrWindow", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., non-SQL-Database resource or PITR not enabled)", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource not found", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getPitrRestoreWindowsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "PitrRestoreWindowsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getRdsNativePitrWindowWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RdsNativePitrWindow", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., non-RDS resource or PITR not enabled)", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource not found", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSnapshotWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetSnapshotResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSnapshotCoverageWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "SnapshotCoverage", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid project or snapshot id.", undefined, response.headers, response);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Insufficient permissions to read the snapshot\&#39;s coverage.", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getUnifiedIdentityRestorePlanWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "UnifiedRestorePlan", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async holdSnapshotWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "any", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid snapshot hold requested. This includes attempts to hold PiTR snapshots, which aren\&#39;t supported. ", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listAzureSqlRestoreTargetServersWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "AzureSqlRestoreTargetServers", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., non-SQL-Database resource)", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource not found", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listEksClusterSnapshotNamespacesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "EksBackupNamespaces", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listEksRestoreTargetClustersWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "EksRestoreTargetClusters", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listResourceSnapshotsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListInventorySnapshotsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Resource wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async removeSnapshotHoldWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "any", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "MPAInterceptedResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureDiskWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Volume, snapshot, or restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureEntraIdWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureFileShareWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request input.", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzurePostgresDatabaseWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureSqlDatabaseWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureSqlDatabaseNativePitrWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., restore time outside PITR window, non-SQL-Database resource, both or neither restore mode specified)", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureSqlVmPitrWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request input, or the requested restore timestamp is outside the available PITR range for this resource.", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureVmInstanceWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreAzureVmNativeWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request input.", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreBigQueryDatasetWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreBigQueryNativePitrWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., restore time outside time travel window, non-BigQuery resource)", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreBucketWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreCassandraClusterWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreDatabaseWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreDbToRdsSnapshotWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot or restore account not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreDocumentdbWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreDynamoDBTableWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreDynamoDBToExistingTableWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., table not empty, key schema mismatch)", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot, table, or restore account not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreDynamoDBToS3WithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Snapshot or restore account not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreEFSWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreEbsVolumeWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Volume, snapshot, or restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreEc2InstanceWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreEksClusterWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreEntraIdWithMicrosoft365WithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreFSxWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreFilesWithHttpInfo(response) {
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGcpCloudSqlWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGcpDiskWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGcpVmInstanceWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceDriveWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceGroupWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceGroupByEntityWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceGroupMessagesWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceGroupMessagesByEntityWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceMailWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceSharedDriveWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceSharedDriveByEntityWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceUserWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceUserByEntityWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceUserDriveByEntityWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreGoogleWorkspaceUserMailByEntityWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreKeyspacesTableWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreMicrosoft365WithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreMicrosoft365DriveWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreMicrosoft365MailWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreMicrosoft365SiteWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreMicrosoft365UserWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreNeptuneWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreOpenSearchDomainWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project, resource, or snapshot wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreRdsNativePitrWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., restore time outside PITR window, non-RDS resource)", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Project or resource not found", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async restoreToEbsSnapshotWithHttpInfo(response) {
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreJobInitiationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Volume, snapshot, or restore account not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
